<template>
  <transition name="fade" v-if="!fadeOut">
    <div class="hmt-preloader">
        <div class="hmt-preloader__container">
          <LoaderIcon />
        </div>
    </div>
  </transition>
</template>

<script>
  import LoaderIcon from '@/assets/svg/loader-radiate.svg';

  export default {
    name: 'HMTPreloader',
    components: {
      LoaderIcon
    },
    props: {
			fadeOut: {
				default: true,
				type: Boolean
			}
		}
  };
</script>

<style lang="scss" scoped>
  @import '../../styles/animations.scss';

  .hmt-preloader {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999999999;
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    height: 100%;
    background-color: #fff;

    &__container {
      display: block;
      margin: auto;
      text-align: center;
    }
    
    svg {
      width: 105px;
    }
  }
</style>
